import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import {
  FaToggleOn, FaToggleOff, FaEdit, FaGift,
  FaPercentage, FaEnvelope, FaChartLine
} from 'react-icons/fa';
import { UserModel } from '../../../models/UserModel';

type CommissionType = {
  id: number;
  commissionPercentage: number;
  isActive: boolean;
  description?: string;
  validFrom?: string;
  validUntil?: string;
};

interface ActionButtonsProps {
  localUser: UserModel;
  commission: CommissionType | null;
  loadingComm: boolean;
  emailLoading: boolean;
  onShowPromoModal: () => void;
  onEmailAutorisation: () => void;
  onToggleCommission: () => void;
  onOpenCommissionModal: () => void;
  onShowPlafondModal: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  localUser,
  commission,
  loadingComm,
  emailLoading,
  onShowPromoModal,
  onEmailAutorisation,
  onToggleCommission,
  onOpenCommissionModal,
  onShowPlafondModal,
}) => {
  if (loadingComm) {
    return (
      <div className="text-center mt-4">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div className="text-center mt-4">
      <div className="d-flex justify-content-center mt-4 flex-wrap gap-2">
        {/* Bouton Envoyer code promo */}
        <Button 
          variant="unstyled"
          className="me-2 btn-custom btn-custom-green"
          onClick={onShowPromoModal}
        >
          <FaGift/> 
          Envoyer un code promo
        </Button>

        {/* Bouton Autorisation email */}
        <Button 
          variant="unstyled"
          className={`me-2 btn-custom ${localUser.email_autorized ? 'btn-custom-red' : 'btn-custom-green-email'}`}
          onClick={onEmailAutorisation}
          disabled={emailLoading}
          style={{
            minWidth: '220px',
            justifyContent: 'center'
          }}
        >
          {emailLoading ? (
            <>
              <Spinner animation="border" size="sm" />
              Chargement...
            </>
          ) : (
            <>
              <FaEnvelope />
              {localUser.email_autorized 
                ? "Bloquer l'envoi d'emails" 
                : "Autoriser l'envoi d'emails"
              }
            </>
          )}
        </Button>

        {commission && (
          <>
            {/* Bouton Toggle Commission */}
            <Button 
              variant="unstyled"
              className={`me-2 btn-custom ${commission.isActive ? 'btn-custom-gray' : 'btn-custom-amber'}`}
              onClick={onToggleCommission}
              style={{ 
                minWidth: '200px'
              }}
            >
              {commission.isActive ? (
                <>
                  <FaToggleOn style={{ fontSize: '1.2em' }} />
                  Désactiver la commission
                </>
              ) : (
                <>
                  <FaToggleOff style={{ fontSize: '1.2em' }} />
                  Activer la commission
                </>
              )}
            </Button>

            {/* Bouton Modifier Commission */}
            <Button 
              variant="unstyled"
              className="btn-custom btn-custom-blue"
              onClick={onOpenCommissionModal}
            >
              <FaEdit />
              Modifier la commission
            </Button>
          </>
        )}

        {localUser.user_type === "professionnel" && (
          <Button 
            variant="unstyled"
            className="ms-2 btn-custom btn-custom-purple"
            onClick={onShowPlafondModal}
          >
            <FaChartLine />
            Modifier le plafond
          </Button>
        )}

        {!commission && (
          <Button 
            variant="unstyled"
            className="ms-2 btn-custom btn-custom-yellow"
            onClick={onOpenCommissionModal}
          >
            <FaPercentage />
            Attribuer une commission
          </Button>
        )}
      </div>
    </div>
  );
};

export default ActionButtons;